<template>
  <v-layout row justify-center class="detalle-pago">
    <v-dialog width="400" v-model="popupCodigoPagoProp.popupCodigoDetalle" class="dialog-pago-efectivo-detalle" persistent>
      <v-card class="pago-efectivo-codigo">
        <v-card-title class="card-title">
          <v-container class="container-title">
            <v-layout class="recuerda-pago-efectivo">
              <v-flex>
                <v-img>
                  <img src="./../../../assets/icons-tarjeta-credito/icon-check-pago-efectivo.svg">
                </v-img>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-title>
        <v-card-text class="card-body">
          <v-container grid-list-md class="text-md-center container-card-body efectivo-card-body">
            <v-layout column class="recuerda-pago-efectivo">
              <v-flex>
                <p class="text-codigo-cip">¡Tu código CIP ha sido generado!</p>
              </v-flex>
              <v-flex>
                <p>Válido solo 24 horas</p>
              </v-flex>
            </v-layout>
            <v-layout column class="recuerda-pago-efectivo box-codigo-pago-efectivo">
              <v-flex>
                <p>{{ popupCodigoPagoProp.codigoPagoEfectivo }}</p>
              </v-flex>
            </v-layout>
            <v-layout column justify-center class="recuerda-pago-efectivo">
              <v-flex>
                <p class="text-codigo-pago-efectivo">¡Listo! Te confirmaremos al correo
                  <br> <b>{{ popupCodigoPagoProp.correoPagoEfectivo }}</b>
                  <br> cuando recibamos el pago.
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row justify-center>
            <v-btn @click="closePopup" class="boton-codigo-pago-efectivo">Entendido</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: [
    "popupCodigoPagoProp",
  ],
  data: () => ({
  }),
  methods: {
    closePopup() {
      this.$emit('popupCodigoPagoMethod')
    }
  }
}
</script>

<style scoped>
@import './../../../assets/css/pago-efectivo/codigoPagoEfectivo.css';
</style>


// WEBPACK FOOTER //
// src/components/payment/pago-efectivo/CodigoPago.vue